
import React, { Component } from 'react'
import PackList from '../PackList'
import PackFocusList from '../PackFocusList'

import Tabs from 'antd/lib/tabs'
// import styles from './index.module.less'

if (__isBrowser__) {
  require('antd/lib/tabs/style/index.css')
}

const styles = require('./index.module.less')
const TabPane = Tabs.TabPane

const TitleContent = (mainTitles, rightTitles, tabType, spm) => {
  if ((mainTitles.length === 0 && mainTitles.length === 0) || tabType === 'TIME') {
    return ''
  }
  if (mainTitles.length > 1) {
    const newMainTitle = []
    mainTitles.map((title, index) => {
      newMainTitle.push(title)
      if (index < mainTitles.length - 1) {
        newMainTitle.push({ isCut: 'true', title: '•' })
      }
    })
    mainTitles = newMainTitle
  }
  return (
    <h2 className={styles.module_title} data-spm={spm}>
      {
        mainTitles.map((mainTitle, index) => {
          if (!mainTitle) {
            return ''
          }
          if (mainTitle.isCut) {
            return <span
              className={styles.main_title_cut}
              key={index}>{mainTitle.title}</span>
          } else {
            return mainTitle.link
              ? <a key={index}
                data-spm={mainTitle.spm}
                className={styles.main_title}
                href={mainTitle.link}> {mainTitle.title} </a>
              : <span
                key={index}
                className={styles.main_title}> {mainTitle.title} </span>
          }
        })
      }

      {
        rightTitles
          ? <a
            className={styles.right_content}
            href={rightTitles.subRightLink}
            target='_blank'>
            {rightTitles.subRightLinkTitle}
          </a>
          : ''}
    </h2>
  )
}

export default class Tab extends Component {
  static defaultProps = {
    components: [], // 组件列表
    defaultActiveKey: '0', // 默认显示的tab索引 字符型
    tabTitle: [], // tabNav标题列表
    mainTitleLinks: [], // 主标题列表
    subRightLinkInfo: [] // 右侧标题
  }
  constructor (props) {
    super(props)
    this.state = {
      key: this.props.defaultActiveKey ? (this.props.defaultActiveKey + '') : '0'
    }
  }

  handleMouseEnter (params) {
    const activeKey = ((params.index) + '')
    if (activeKey === this.state.key) {
      return
    }
    this.setState({ key: activeKey, link: params.link })
  }

  // 构造tab标题
  getTabTitle = (index) => {
    const title = this.props.tabTitle[index]
    const tabTitle = title.name || ''
    let html = ''
    if (title.link) {
      html = (
        <a
          data-spm={title.spm}
          target='_blank'
          href={title.link}
          className={styles.tab_title}
          onMouseEnter={this.handleMouseEnter.bind(this, { index, link: title.link })}>
          {tabTitle}
          {
            title.summary
              ? <span className={styles.tab_sub_title}>{title.summary}</span>
              : ''
          }
        </a>)
    } else {
      html = (
        <div className={styles.tab_title}
          onMouseEnter={this.handleMouseEnter.bind(this, { index, link: title.link })}>
          {tabTitle}
          { title.summary ? <span className={styles.tab_sub_title}>{title.summary}</span> : ''}
        </div>)
    }
    return html
  }

  render () {
    return (
      <Tabs ref='Tabs'
        activeKey={this.state.key}
        tabBarExtraContent={
          TitleContent(
            this.props.mainTitleLinks,
            this.props.subRightLinkInfo,
            this.props.tabType,
            this.props.spm)
        }
        className={this.props.tabType === 'TIME' ? styles.component_chasing : styles.component_tabs}
        animated={false}>

        {
          this.props.components.map((component, index) => (
            <TabPane
              tab={this.getTabTitle(index)}
              key={index}
              data-spm={component.spm}
              data-name='c_pos'
              data-mname={component.trackInfo.drawer}
              data-cname={component.trackInfo.component_title}
              data-cid={component.trackInfo.component_id}
              data-mid={component.trackInfo.drawerid}
              data-trackinfo={JSON.stringify(component.trackInfo)}>
              {
                (component.isFocus
                  ? <PackFocusList
                    list={component.itemList}
                    isHorizontal={component.isHorizontal}
                    isOneLineTitle={component.isOneLineTitle} />
                  : <PackList list={component.itemList}
                    isHorizontal={component.isHorizontal}
                    rank={component.isRank}
                    isOneLineTitle={component.isOneLineTitle}
                    row={component.totalLine || 2} />)
              }
            </TabPane>
          ))}
      </Tabs>)
  }
}
